"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.useUserStore = (0, pinia_1.defineStore)("userStore", {
    state: () => ({
        loading: false,
        users: [],
        totalUsers: 0,
    }),
    getters: {},
    actions: {
        getUsers(router, query) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "admin_users_api", query: query }).href)
                    .then((response) => {
                    let users = [];
                    if (Array.isArray(response["hydra:member"])) {
                        response["hydra:member"].forEach((element) => {
                            if (element["@type"] !== "User") {
                                return;
                            }
                            users.push(element);
                        });
                    }
                    this.users = users;
                    this.loading = false;
                    this.totalUsers = response["hydra:totalItems"];
                    resolve(response);
                })
                    .catch((error) => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        reset() {
            this.users = [];
            this.totalUsers = 0;
        },
        createUser(router, userRequest) {
            this.loading = true;
            let options = { body: JSON.stringify(userRequest), method: "POST" };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "admin_users_api" }).href, options)
                    .then((response) => {
                    this.loading = false;
                    resolve(response);
                })
                    .catch((error) => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        updateUser(router, userRequest, id) {
            this.loading = true;
            let options = { body: JSON.stringify(userRequest), method: "PATCH" };
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "admin_users_api", params: { id: id } }).href, options)
                    .then((response) => {
                    this.loading = false;
                    resolve(response);
                })
                    .catch((error) => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
        deleteUser(router, id) {
            this.loading = true;
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)(router.resolve({ name: "admin_users_api", params: { id: id } }).href, { method: "DELETE" })
                    .then((response) => {
                    this.loading = false;
                    resolve();
                })
                    .catch((error) => {
                    this.loading = false;
                    reject(error);
                });
            });
        },
    },
});
